module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/2-f04b56626add03a896e033c8aee483fe.png";